import axios from 'axios'

const scategorias = {
    GetCategorias: () => axios.get("categorias/listar"),
};
export default scategorias